import React from 'react'

const About = () => {
    return (
        <div>
          <h1>About this App</h1>  
          <p>App to Search Github Users</p>
          <p>Version : 2.0.0</p>
        </div>
    )
}

export default About
